import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.67 2.63a.7.7 0 0 0-.71.7v9.5l1.03-.68a.63.63 0 0 1 .79.07l.89.9.89-.9a.62.62 0 0 1 .88 0l.9.9.88-.9a.63.63 0 0 1 .8-.07l1.02.68v-9.5a.7.7 0 0 0-.7-.7H4.66Zm-1.39-.68c.37-.37.87-.57 1.39-.57h6.66a1.96 1.96 0 0 1 1.96 1.95V14a.62.62 0 0 1-.97.52l-1.57-1.05-.97.97a.62.62 0 0 1-.89 0L8 13.55l-.9.9a.62.62 0 0 1-.88 0l-.97-.98-1.57 1.05a.62.62 0 0 1-.97-.52V3.33c0-.52.2-1.01.57-1.38ZM5.38 5c0-.35.27-.63.62-.63h4a.62.62 0 0 1 0 1.25H6A.62.62 0 0 1 5.37 5Zm0 2.5c0-.35.27-.63.62-.63h4a.62.62 0 0 1 0 1.25H6a.62.62 0 0 1-.63-.62Zm2 2.5c0-.35.27-.63.62-.63h2a.62.62 0 0 1 0 1.26H8a.62.62 0 0 1-.63-.63Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }